import { Check } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "../Reveal";

const FEATURES = [
  "8 compartiments identiques",
  "Compartiments indépendants",
  "Compartiments amovibles et lavables (prévu)",
  "Couvercle transparent",
  "Fermetures robustes",
  "Format professionnel ≈ 45 × 35 × 12 cm",
];

export default function Product() {
  return (
    <section id="produit" className="py-16 sm:py-24" data-testid="product-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <Eyebrow>Le produit</Eyebrow>
          <SectionTitle>Un format professionnel, pensé pour le terrain.</SectionTitle>
          <p className="mt-6 text-gray-400 leading-relaxed max-w-lg">
            STOCKBOX 8 est une boîte de rangement connectée au format professionnel,
            conçue pour le véhicule et le chantier. Le concept actuel associe un couvercle
            transparent, des fermetures robustes et 8 compartiments de rangement.
          </p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-3 text-sm text-gray-300" data-testid={`product-feature-${f.slice(0, 12).replace(/\s/g, "-")}`}>
                <Check size={16} className="text-[#FFC700] mt-0.5 shrink-0" /> {f}
              </li>
            ))}
          </ul>
          <p className="mt-6 font-mono text-xs uppercase tracking-widest text-gray-500">
            Dimensions indicatives — susceptibles d'évoluer pendant le développement
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="space-y-4">
            <div className="border border-[#2E333D] rounded-2xl overflow-hidden bg-[#141619]" data-testid="product-image-open">
              <img src="/images/product-open.jpg" alt="Concept STOCKBOX 8 ouvert — 8 compartiments noirs identiques et amovibles, couvercle transparent" className="w-full h-auto object-cover" loading="lazy" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
